import { render, staticRenderFns } from "./textAction.vue?vue&type=template&id=7254780e&"
import script from "./textAction.vue?vue&type=script&lang=js&"
export * from "./textAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports